import { ButtonProps } from 'blaze-ui/Button/Types'
import { useImagePickerContext } from './ImagePickerContext'
import { Button } from 'blaze-ui/Button'
import { pluralize } from 'utils'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { entityName } from './utils'
import { capitalize } from 'lodash'

interface Props extends Pick<ButtonProps, 'onPress' | 'isDisabled' | 'size'> {
  confirmLabel?: string
}

export const ConfirmSelectionButton = ({ onPress, isDisabled, confirmLabel, size = 'lg' }: Props) => {
  const { selectedImages, isUploading } = useImagePickerContext()
  const { isMobile } = useResponsiveDesign()

  if (isMobile) {
    return (
      <Button isDisabled={isUploading || isDisabled} onPress={onPress} size="lg" fullWidth>
        {isUploading ? 'Adding Media...' : confirmLabel || 'Add To Post'}
      </Button>
    )
  }

  return (
    <Button onPress={onPress} isDisabled={isUploading || isDisabled} size={size}>
      {confirmLabel || `Insert ${pluralize(capitalize(entityName(selectedImages)), selectedImages.length)}`}
    </Button>
  )
}
